import {
  tokens,
  Typography,
  useSingletonMobileMediaQuery,
} from "@sunrun/experience-ui-components";
import { ReactNode } from "react";
import { ReviewLoanSummary } from "../../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import { formatCurrency } from "../../../utils/formatHelpers";
import {
  PaymentCard,
  PaymentCardHeader,
  PaymentColumn,
  PaymentLineItem,
  PaymentRows,
  PaymentValidUntil,
} from "./OfferReviewPaymentPrimitives";

type LoanPaymentDetailsProps = {
  summary: ReviewLoanSummary;
  productLabel: string;
  showValidUntil: boolean;
  children?: ReactNode;
};

const LoanPaymentDetails = ({
  summary,
  productLabel,
  showValidUntil,
  children,
}: LoanPaymentDetailsProps) => {
  const isMobile = useSingletonMobileMediaQuery();

  return (
    <PaymentCard $opacity={0.4} data-testid="offer-review-simplified-payment">
      <PaymentCardHeader $isMobile={isMobile}>
        <Typography
          size={isMobile ? 28 : 32}
          fontWeight="medium"
          color={tokens.BRAND_HERO_BLUE}
        >
          {productLabel}
        </Typography>
      </PaymentCardHeader>
      <PaymentColumn>
        <Typography
          size={20}
          fontWeight="medium"
          color={tokens.BRAND_HERO_BLUE}
        >
          Agreement details
        </Typography>
        <PaymentRows>
          <PaymentLineItem
            label="Loan payment"
            labelSize={16}
            labelWeight="medium"
            value={formatCurrency(summary.monthlyWithVoluntary)}
            unit="/mo"
            valueSize={20}
            valueWeight={600}
          />
          <PaymentLineItem
            label="Total loan amount"
            value={formatCurrency(summary.total)}
          />
          <PaymentLineItem
            label="APR includes 0.50% autopay discount"
            value={`${summary.apr}%`}
          />
          <PaymentLineItem
            label="Loan term"
            value={String(summary.termYears)}
            unit="years"
          />
          <PaymentLineItem
            label="Due at agreement"
            value={formatCurrency(summary.dueAtSigning, 0)}
          />
        </PaymentRows>
      </PaymentColumn>
      {children}
      {showValidUntil && <PaymentValidUntil expires={summary.expires} />}
    </PaymentCard>
  );
};

export { LoanPaymentDetails };
